module.exports = __webpack_public_path__ + "img/0.06a14c93.png";